import { useNutritionFlags } from "apps/web/src/hooks/useNutritionFlags";
import { useEditMenuItemAllergensMutation } from "apps/web/src/types";
import { useSnackbar } from "../../Snackbar/SnackbarContext";

export type SaveMenuItemAllergens = (menuItemId: string, selfAllergens: string[] | null) => Promise<void>;

// The create/edit mutations take no allergens, so they are saved in place on the resulting menu item right after
export const useSaveMenuItemAllergens = (): SaveMenuItemAllergens => {
  const { isRecipeAndMenuItemAllergensEnabled } = useNutritionFlags();
  const { setMessage } = useSnackbar();
  const [editMenuItemAllergens] = useEditMenuItemAllergensMutation();

  return async (menuItemId, selfAllergens) => {
    if (!isRecipeAndMenuItemAllergensEnabled) {
      return;
    }
    try {
      await editMenuItemAllergens({ variables: { input: { id: menuItemId, selfAllergens } } });
    } catch {
      setMessage("error", "The menu item was saved but its allergens could not be saved");
    }
  };
};
